export default {
    noData: 'No assessment data available. Please complete the evaluation first.',
    noAssessments: 'No competencies have been assessed yet.',
    summary: {
        title: "{{name}}'s Assessment Results",
        subtitle: 'Overview of the performance assessment',
        competenciesAssessed: 'Competencies assessed',
        averageScore: 'Average score',
        completionRate: 'Completion rate',
        complete: 'Complete',
        partial: 'Partial',
        exceedsExpectations: 'Exceeds Expectations',
        meetsExpectations: 'Meets Expectations',
        needsImprovement: 'Needs Improvement',
        below: 'Below Expectations',
    },
    tabs: {
        competences: 'Competencies',
        strengthsAndAreas: 'Strengths & Development',
    },
    competency: {
        exceedsExpectations: 'Exceeds',
        meetsExpectations: 'Meets',
        needsImprovement: 'Developing',
        belowExpectations: 'Below',
        notAssessed: 'Not yet assessed',
        previousStatus: 'Previous:',
        statusNotMet: 'Not Met',
        statusInEvolution: 'In Evolution',
        statusAlmostAchieved: 'Almost Achieved',
        statusAchieved: 'Achieved',
        deactivated: 'Deactivated competency',
    },
    strengths: {
        title: 'Strengths',
    },
    developmentAreas: {
        title: 'Development Areas',
    },
    notes: {
        title: 'Notes',
        empty: 'No notes available',
    },
    meetingPreparation: {
        title: 'Prepare your meeting with {{name}}',
        description:
            'Let Amélio AI generate your meeting agenda based on the assessment and insights gathered.',
        button: 'Prepare meeting',
    },
};
